import { addAsset } from "../../components/utilities";

export const FilterComponent = {
  root: document.querySelector('#component-products-filter-root'),
  button: document.querySelector('#open-filter-mobile'),
  settings: window.filterSettings || false,
  showPriceSlider: false,
  instance: false,

  sortArrayValues: function (array, property) {
    let sortedArray = array.sort((a, b) => {
      if (a[property] < b[property]) return -1
      if (b[property] > b[property]) return 1
      return 0
    })

    // Define ordenação dos tamanhos
    const customOrder = ['pp', 'p', 'm', 'g', 'gg', 'xg', 'xgg']
    sortedArray.forEach(item => {
      item.sort = 99
      customOrder.forEach((order, index) => {
        if (item[property].toLowerCase() === order) item.sort = index
      })
    })

    return sortedArray.sort((a, b) => {
      if (a.sort < b.sort) return -1
      if (b.sort > b.sort) return 1
      return 0
    })
  },

  setTagTypes: function () {
    const { settings } = FilterComponent;
    const tags = [];

    if (settings.aggregations) {
      const aggregations = settings.aggregations

      // Filtro de categoria
      if (aggregations.types.categoria) tags.push({
        title: 'Categoria',
        type: 'categoria',
        style: 'list',
        options: FilterComponent.sortArrayValues(aggregations.types.categoria, 'title')
      })
    }

    return tags
  },

  setProperties: function () {
    const { settings } = FilterComponent;
    const properties = [];

    if (settings.aggregations) {
      const aggregations = settings.aggregations

      // Filtros Atributo 1
      if (aggregations.properties.property1.length > 0) properties.push({
        title: 'Cor',
        property: 'property1',
        style: 'colors',
        colorsProps: {
          showTitle: true,
          showColor: true,
        },
        options: FilterComponent.sortArrayValues(aggregations.properties.property1, 'value'),
        patterns: settings.patterns
      })

      // Filtros Atributo 2
      if (aggregations.properties.property2.length > 0) properties.push({
        title: 'Tamanho',
        property: 'property2',
        style: 'list',
        options: FilterComponent.sortArrayValues(aggregations.properties.property2, 'value'),
        patterns: settings.patterns
      });

      // Filtros Atributo 3
      if (aggregations.properties.property3.length > 0) properties.push({
        title: 'Fragrância',
        property: 'property3',
        style: 'list',
        options: FilterComponent.sortArrayValues(aggregations.properties.property3, 'value'),
        patterns: settings.patterns
      });

    }

    return properties
  },

  setPricesRanges: function () {
    const { settings, showPriceSlider } = FilterComponent
    let priceSettings = {
      price: false,
      priceProps: false
    }

    // Exibe o slider de preço. Caso tenha faixas de preço,
    // preferência fica para as faixas (abaixo)
    if (showPriceSlider) {
      priceSettings.price = [
        settings.aggregations.min_price,
        settings.aggregations.max_price
      ]
    }

    // Exibe as opções de faixa de preço
    if (settings.prices_range.length > 0) {
      priceSettings.priceProps = {
        mode: 'options',
        options: settings.prices_range
      }
      priceSettings.price = [
        settings.aggregations.min_price,
        settings.aggregations.max_price
      ]
    }

    return priceSettings
  },

  setFilters: function () {
    const { root, settings } = FilterComponent;
    const tags = FilterComponent.setTagTypes();
    const properties = FilterComponent.setProperties();
    const priceSettings = FilterComponent.setPricesRanges();
    const hasSort = settings.has_sort || false;

    const componentFilters = new Vnda.Component.ProductsFilter({
      mode: 'drawer',
      filtersStartOpen: false,
      showAppliedFilters: false,
      hasSort: hasSort,
      filterOnClick: false,
      resetMode: 'all',
      tags,
      properties,
      price: priceSettings.price,
      priceProps: priceSettings.priceProps
    });

    // Renderiza o componente
    componentFilters.render(root);
    FilterComponent.instance = componentFilters
    root.dispatchEvent(new Event('vnda:filter-component-loaded'))
  },

  loadFilters: function () {
    const { settings } = FilterComponent;
    if (!settings) return;
    addAsset(settings.script, FilterComponent.setFilters)
    addAsset(settings.styles)
  },

  show: function () {
    const { root } = FilterComponent;

    if (!FilterComponent.instance) {
      FilterComponent.loadFilters()
      root.addEventListener('vnda:filter-component-loaded', () => {
        FilterComponent.instance.toggle()
      })
    } else {
      FilterComponent.instance.toggle()
    }
  },

  // Função que trata o filtro de ordenação customizado
  // Descomentar caso seja utilizado
  // handleSortFilter: function () {
  //   const filterSort = document.querySelector('[data-filter-sort]');
  //   if (!filterSort) return;

  //   const filterSortList = filterSort.querySelector('.list');
  //   if (!filterSortList) return;

  //   const filterSortOptions = filterSortList.querySelectorAll('.item .input');
  //   const filterSortButton = filterSort.querySelector('.button-default');

  //   if (!filterSortButton || !filterSortOptions.length > 0) return;

  //   const filterSortSelected = filterSortButton.querySelector('.text');

  //   const urlParams = new URLSearchParams(window.location.search);
  //   const sortCurrentValue = urlParams.get('sort');

  //   // Verifica se o parâmetro de ordenação existe na URL      
  //   const selectedSortOption = [...filterSortOptions].find((option) => {
  //     const optionValue = option.getAttribute('value');
  //     return optionValue === sortCurrentValue;
  //   })

  //   // Se o parâmetro de ordenação existir, marca a opção correspondente
  //   if (selectedSortOption) {
  //     selectedSortOption.checked = true;
  //     filterSortSelected.innerHTML = selectedSortOption.parentElement.querySelector('.text').innerHTML;
  //   }


  //   // Altera a url sem subsscrever ou limpar os parâmetros
  //   filterSort.addEventListener('submit', (event) => {
  //     event.preventDefault();
  //     const formData = new FormData(filterSort);
  //     const sortValue = formData.get('sort');
  //     const url = new URL(window.location.href);

  //     sortValue
  //       ? url.searchParams.set('sort', sortValue)
  //       : url.searchParams.delete('sort');

  //     // URL substituí espaços em branco por '+', e isso causa confilto com o componente
  //     // Componente utiliza colchetes na URL. Quando URL params é utilizado, ele retorna o caractere encodado.
  //     // É necessário substituir o caractere encodado para que funcione com o componente
  //     const formattedUrl = url.toString().replaceAll('+', '%20').replaceAll('%5D', ']').replaceAll('%5B', '[');
  //     window.location.href = formattedUrl;
  //   })

  //   // Envia o formulário na mudança do filtro
  //   filterSortOptions.forEach((option) => {
  //     option.addEventListener('click', (event) => {
  //       event.preventDefault();
  //       const optionText = option.parentElement.querySelector('.text');

  //       // Altera o estado de seleção do input radio
  //       setTimeout(() => {
  //         option.checked ? option.checked = false : option.checked = true;
  //         if (filterSortSelected && optionText) filterSortSelected.innerHTML = optionText.innerHTML;
  //         filterSort.requestSubmit();
  //       }, 5)
  //     })
  //   });

  //   // Armazena o intervalo na interação de mouseenter e mouseleave
  //   let interactionTimeout = null;

  //   // Eventos de exibição do filtro
  //   filterSortButton.addEventListener('mouseenter', () => {
  //     // Limpa o intervalo entre interações
  //     if (interactionTimeout) {
  //       clearTimeout(interactionTimeout);
  //       interactionTimeout = null
  //     }

  //     !filterSortButton.classList.contains('-opened')
  //       && filterSortButton.classList.add('-opened');

  //     !filterSortList.classList.contains('-opened')
  //       && filterSortList.classList.add('-opened');
  //   });

  //   filterSort.addEventListener('mouseleave', () => {
  //     // Considera um intervalo entre interações para não ter conflitos no hover
  //     interactionTimeout = setTimeout(() => {
  //       filterSortButton.classList.remove('-opened');
  //       filterSortList.classList.remove('-opened');
  //     }, 300);
  //   });

  // },

  init: function () {

    const { root, button } = FilterComponent

    if (!root) return

    // Função que trata o filtro de ordenação customizado
    // Descomentar caso seja utilizado
    // FilterComponent.handleSortFilter();

    if (button) {
      button.addEventListener('click', () => {
        FilterComponent.show()
      })
    } else {
      FilterComponent.loadFilters()
    }
  }
}